import * as React from "react";
import { Link } from "react-router-dom";

import translate from "../../translations/i18n";
import CtaButton from "../ctaButton/ctaButton";
import "../../style/fonts.css";
import "./downloadUserData.css";
import { getVal, firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { connect } from "react-redux";
import ProfileData from "src/interfaces/models/profileData";
import { SmokingData } from "src/interfaces/models/smokingData";
import UserData from "src/interfaces/models/userData";
import { HighfivesData } from "src/interfaces/models/highfivesData";

export interface Props {
  ownAuth: any;
  profile: ProfileData;
  smoking: SmokingData;
  user: UserData;
  highFives: HighfivesData;
}

// $roots keeps previous parent properties as they will be added as a prefix for each prop.
// $sep is just a preference if you want to seperate nested paths other than dot.
export const flatten = (obj, roots = [], sep = "_") => {
  return Object.keys(obj).reduce((previousObject, index) => {
    const thirdObject =
      Object.prototype.toString.call(obj[index]) === "[object Object]"
        ? flatten(obj[index], roots.concat([index]))
        : Array.isArray(obj[index])
        ? flatten(obj[index], roots.concat([index]))
        : { [roots.concat([index]).join(sep)]: obj[index] };
    return Object.assign({}, previousObject, thirdObject);
  }, {});
};

class DownloadUserData extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  handleClick = () => {
    const flatDataProfile = this.props.profile
      ? flatten(this.props.profile)
      : {};
    const flatDataUser = this.props.profile ? flatten(this.props.user) : {};
    const flatDataSmoking = this.props.profile
      ? flatten(this.props.smoking)
      : {};
    const flatDataHighFives = this.props.profile
      ? flatten(this.props.highFives)
      : {};

    const keys = Object.keys(flatDataProfile).concat(
      Object.keys(flatDataProfile),
      Object.keys(flatDataUser),
      Object.keys(flatDataSmoking),
      Object.keys(flatDataHighFives)
    );
    const values = Object.values(flatDataProfile).concat(
      Object.values(flatDataProfile),
      Object.values(flatDataUser),
      Object.values(flatDataSmoking),
      Object.values(flatDataHighFives)
    );

    const csvContent =
      "data:text/csv;charset=utf-8," +
      keys.map((e, index) => e + ";" + values[index]).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "SmokelessUserData.csv");
    document.body.appendChild(link); // Required for FF

    link.click();
  };

  render() {
    return (
      <div className="downloadUserData-cont">
        <div className="downloadUserData-cont-center">
          <div className="downloadUserData__headline">
            <div className="TITLE_2">
              {translate("DOWNLOAD_USERDATA_TITLE")}
            </div>
          </div>
          <div className="downloadUserData__text">
            <div className="REG_TEXT ">
              {translate("DOWNLOAD_USERDATA_TEXT")}
            </div>
          </div>
          {this.props.ownAuth.uid ? (
            <div
              className="downloadUserData__button-cont"
              onClick={this.handleClick}
            >
              <CtaButton
                width={"280px"}
                text={translate("CTA_DOWNLOAD_USERDATA")}
                color={"white"}
                disabled={!this.props.ownAuth.uid}
              />
            </div>
          ) : (
            <div className="downloadUserData__button-cont">
              <Link to={"/login/:downloadUserData"}>
                <CtaButton
                  width={"280px"}
                  text={translate("CTA_LOGIN")}
                  color={"white"}
                />
              </Link>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = state.firebase.auth.uid;
  return {
    ownAuth: state.firebase.auth,
    profile: getVal(state.firestore, `data/profile[${id}]`),
    smoking: getVal(state.firestore, `data/smoking[${id}]`),
    user: getVal(state.firestore, `data/users[${id}]`),
    highFives: getVal(state.firestore, `data/highfives[${id}]`),
  };
};

export default compose<any>(
  connect(mapStateToProps),
  firestoreConnect((props) => [
    { collection: "profile", doc: props.ownAuth.uid },
    { collection: "users", doc: props.ownAuth.uid },
    { collection: "smoking", doc: props.ownAuth.uid },
    { collection: "highfives", doc: props.ownAuth.uid },
  ])
)(DownloadUserData);



// WEBPACK FOOTER //
// ./src/components/screens/downloadUserData.tsx